export class DeactivateGcpOrganizationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpOrganization",
            "baseName": "gcpOrganization",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateGcpOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
